import Scriba from 'react-scriba';

export class DataCompteMandatOperationNiveauAlerte {

    static _onEnregistrementCompteMandatOperationNiveauAlerte = (loginCompte, idOperation, idNiveauAlerte) => {
        const objet = {
            "loginCompte": loginCompte,
            "idOperation": idOperation,
            "idNiveauAlerte": idNiveauAlerte,
        };
        const url = "api/MAJDonnees/EnregistrementCompteMandatOperationNiveauAlerte";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json())
    };

    static _onSuppresionCompteMandatOperationNiveauAlerte = (loginCompte, idOperation, idNiveauAlerte) => {
        const objet = {
            "loginCompte": loginCompte,
            "idOperation": idOperation,
            "idNiveauAlerte": idNiveauAlerte,
        };
        const url = "api/MAJDonnees/SuppressionCompteMandatOperationNiveauAlerte";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json())
    };

    static _onEnregistrementCompteMandatOperationNiveauAlerteGlobale = (loginCompte, idNiveauAlerte) => {
        const objet = {
            "loginCompte": loginCompte,
            "idNiveauAlerte": idNiveauAlerte,
        };
        const url = "api/MAJDonnees/EnregistrementCompteMandatOperationNiveauAlerteGlobale";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json())
    };

    static _onSuppressionCompteMandatOperationNiveauAlerteGlobale = (loginCompte, idNiveauAlerte) => {
        const objet = {
            "loginCompte": loginCompte,
            "idNiveauAlerte": idNiveauAlerte,
        };
        const url = "api/MAJDonnees/SuppressionCompteMandatOperationNiveauAlerteGlobale";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json())
    };
}